import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSession } from '../../context/SessionContext';
import { useNavigation } from '../../hooks/useNavigation';
import { Footer } from '../ui';

function DoNotCheat() {
  const { eid } = useSession();
  const { navigateNext, navigatePrevious } = useNavigation();
  const location = useLocation();

  const handleNext = () => {
    navigateNext(location.pathname);
  };

  const handlePrevious = () => {
    navigatePrevious(location.pathname);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      <div className="w-full max-w-[800px] bg-[#FFFBEB] border-2 border-[#D4AF37] rounded-3xl shadow-lg p-12">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-6">
            <img
              src="/nocheatingicon.svg"
              alt="No cheating"
              className="w-full h-full"
            />
          </div>
          <h2 className="text-3xl font-bold mb-8" style={{ color: '#7C0000' }}>Integrity Notice</h2>
        </div>
        
        <div className="space-y-6 mb-10 px-4">
          <p className="text-lg text-center leading-relaxed" style={{ color: '#7C0000' }}>
            Please note that this evaluation uses behavioural pattern recognition, typing or speech biometrics, event logging, and other methods to ensure integrity and authenticity.
          </p>
          
          <p className="text-lg text-center leading-relaxed font-bold" style={{ color: '#7C0000' }}>
            Evaluations with misconduct are disqualified.
          </p>
        </div>
        
        <div className="flex justify-center w-full space-x-4 mt-10">
          <button 
            onClick={handlePrevious} 
            className="bg-[#FEF3C7] hover:bg-[#FDE68A] font-semibold rounded-lg px-8 py-3 text-lg transition-colors duration-200"
            style={{ color: '#7C0000' }}
          >
            Back
          </button>
          <button 
            onClick={handleNext} 
            className="bg-[#B45309] hover:bg-[#92400E] text-white font-semibold rounded-lg px-8 py-3 text-lg transition-colors duration-200 shadow-md"
          >
            I Understand
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default DoNotCheat;
